import { API_SERVICE } from "./root";
//  导入pb文件
//  ticket的proto
import { UserServiceClient } from "@/pbjs/external/user/user_grpc_web_pb";
//  命名请求对象
let userClient: any = new UserServiceClient(API_SERVICE, null, null);

export { userClient };
